import { useDarkMode } from 'usehooks-ts'

export type ThemeMode = 'dark' | 'light'

// TODO When dark mode is supported update to return 'dark' if isDarkMode
export function useLightMode() {
  const { isDarkMode } = useDarkMode()
  // Always return light mode for now
  const mode: ThemeMode = isDarkMode ? 'light' : 'light'
  return mode
}
